import {IDictionary} from "vizixc/dist/services/vizixClient.service";

export class TableScriptReportResponse {
  columnNames: Array<string>;
  extraColumnNames: Array<string>;
  data: Array<Array<string>>;
  extra: Array<Array<string>>;
  options: IDictionary<string, any>;
  rowNames: Array<any>;
  totalRows: number;
  title: string;
  overs: number;
  lstOvers: Array<string>;
  isProcessing: boolean;
  extraOriginal: Array<Array<string>>;
}



// WEBPACK FOOTER //
// ./src/models/TableScriptReportResponse.ts